import React from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';
import {useTheme} from '@rneui/themed';

import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type RewardsLinkColor = 'linkPrimary' | 'linkOnSurface';
type RewardsLinkSize = 'body2' | 'body1';

type RewardsLinkProps = {
  onPress: () => void;
  children: string;
  color?: RewardsLinkColor;
  weight?: '400' | '600';
  align?: 'flex-start' | 'center' | 'flex-end';
  size?: RewardsLinkSize;
  testID?: string;
  accessibilityLabel?: string;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
};

function RewardsLink({
  onPress,
  children,
  color = 'linkPrimary',
  weight = '600',
  align = 'flex-start',
  size = 'body2',
  testID,
  accessibilityLabel,
  disabled = false,
  style,
}: RewardsLinkProps) {
  const {theme} = useTheme();

  const textColor = theme.colors[color] ?? '#1A56DB';

  const containerStyle: ViewStyle = {
    minHeight: 44,
    minWidth: 44,
    justifyContent: 'center',
    alignItems: align,
    paddingVertical: 8,
  };

  return (
    <PressableWithOpacityFeedback
      onPress={disabled ? undefined : onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? children}
      accessibilityState={{disabled}}
      testID={testID}
      style={[containerStyle, style]}>
      <View pointerEvents="none">
        <Text
          variant={size}
          style={{
            color: disabled ? theme.colors.grey3 : textColor,
            fontWeight: weight,
          }}>
          {children}
        </Text>
      </View>
    </PressableWithOpacityFeedback>
  );
}

export default RewardsLink;
